module.exports = __webpack_public_path__ + "static/media/exp3.5c4b8b16.png";